export default __webpack_public_path__ + "static/media/retrieve_diagram_for_users.6942069d.svg";